const eventHandlerMap = /* @__PURE__ */ new Map();
const eventBus = {
  on(event, callback) {
    if (typeof document === "undefined") return;
    const wrappedHandler = (e) => callback(e.detail);
    if (!eventHandlerMap.has(event)) {
      eventHandlerMap.set(event, /* @__PURE__ */ new Map());
    }
    eventHandlerMap.get(event).set(callback, wrappedHandler);
    document.addEventListener(event, wrappedHandler);
  },
  dispatch(event, data) {
    if (typeof document === "undefined") return;
    document?.dispatchEvent(new CustomEvent(event, { detail: data }));
  },
  remove(event, callback) {
    if (typeof document === "undefined") return;
    const eventMap = eventHandlerMap.get(event);
    if (eventMap && eventMap.has(callback)) {
      const wrappedHandler = eventMap.get(callback);
      document.removeEventListener(event, wrappedHandler);
      eventMap.delete(callback);
      if (eventMap.size === 0) {
        eventHandlerMap.delete(event);
      }
    }
  }
};

export { eventBus };
//# sourceMappingURL=src-utils-event-bus.js.map
